import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg18OwnedB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        id: "18-owned-b_svg__a",
        d: "M0 0h8v8H0z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(5 5)",
      children: [/*#__PURE__*/jsx("mask", {
        id: "18-owned-b_svg__b",
        fill: "#fff",
        children: /*#__PURE__*/jsx("use", {
          xlinkHref: "#18-owned-b_svg__a"
        })
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M3.992 8c-.136-.002-.226-.073-.282-.23a5.3 5.3 0 0 0-.755-1.42C2.243 5.404 1.36 4.683.233 4.28Q-.008 4.195 0 3.99c.006-.156.103-.235.241-.287C1.7 3.149 2.77 2.162 3.476.78c.09-.176.156-.363.23-.547.066-.165.15-.234.292-.233.138.001.225.068.285.226.638 1.69 1.825 2.83 3.496 3.485q.223.089.221.29-.004.192-.22.278-2.52.973-3.495 3.49c-.063.164-.152.233-.293.231",
        mask: "url(#18-owned-b_svg__b)"
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18OwnedB$1 = Svg18OwnedB;

export { Svg18OwnedB$1 as default };
